export const TOPBAR_USER_MENU_ITEM_SYMBOLS = ['SEPARATOR', 'PROFILE_SWITCH', 'TAKEOVER'] as const
